import { Component, OnInit, ViewChild } from '@angular/core';
import { ABMRolesService } from '../../../services';
import { MdDialogRef } from '@angular/material';
import { Router } from '@angular/router';

import { PATH_ABM_CATEGORIA_DETAIL } from '../../../navigation/navigation.module';

@Component({
  selector: 'app-new-categoria-dialog',
  templateUrl: './new-categoria-dialog.component.html',
  styleUrls: ['./new-categoria-dialog.component.scss']
})
export class NewCategoriaDialogComponent {

  public name: string;

  constructor(private abmService: ABMRolesService,
              private dialogRef: MdDialogRef<NewCategoriaDialogComponent>,
              private router: Router) { }

  onSubmit(){
    this.abmService.setTmpCategoria({
      "CategoriaNombre": this.name,
      "Acopios": []
    });
    this.dialogRef.close(true);
    this.router.navigate([PATH_ABM_CATEGORIA_DETAIL]);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/new-categoria-dialog/new-categoria-dialog.component.ts